import type { ButtonGroupProps } from '../../ButtonGroup';
import { ButtonGroup } from '../../ButtonGroup';

export type TableSelectionButtonGroupProps = ButtonGroupProps;

const TableSelectionButtonGroup = (props: TableSelectionButtonGroupProps) => (
  <ButtonGroup {...props} />
);

export default TableSelectionButtonGroup;
